var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.validation},[(_vm.type)?[_c('p',[_vm._v("请输入您的手机联系方式")]),_c('p',[_vm._v("获取验证码，进行手机验证")])]:[_c('p',[_vm._v("请进行绑定手机验证")]),_c('p',[_vm._v("绑定手机："+_vm._s(this.phone))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }